module.exports = __webpack_public_path__ + "img/idcard_zhengmian1.c3f14107.png";